import React from "react";
import { BadgeType } from "../types/common";

interface BadgeProps {
	children: React.ReactNode;
	type: BadgeType;
}

export function Badge({ children, type }: BadgeProps) {
	return <span className={`badge bg-${type}`}>{children}</span>;
}
